<template>
    <div v-if="hasToasts">
    <component  v-for="(dialog, index) of dynamics" :is="dialog.component"
      v-bind="dialog"
      @close="remove(dialog)"
      :key="index"
      :ref="dialog.id" />
    </div>
</template>

<script>
const confirm = () => import('components/Dialogs/Confirm.vue');
const loading = () => import('components/Dialogs/Loading.vue');
const blobDialog = () => import('components/Dialogs/BlobPrintDialog.vue');
const batchResult = () => import('components/Dialogs/BatchResult.vue');

export default {
  name: 'Dialogs',
  components: {
  },
  data: function () {
    return {
      dialogs: []
    };
  },
  computed: {
    hasToasts () {
      return this.dialogs.length > 0;
    },
    dynamic () {
      return confirm;
    },
    dynamics () {
      return this.dialogs;
    }
  },
  methods: {
    confirm (msg, title = '', callbackYes = () => {}, callbackNo = null, callbackCancel = () => {}, txtButtonYes, txtButtonNo, txtButtonCancel) {
      let newDialog = {
        id: this.getRandomID(),
        message: msg,
        title: title,
        component: confirm,
        callbackYes: callbackYes,
        callbackNo: callbackNo,
        callbackCancel: callbackCancel,
        txtButtonYes: txtButtonYes,
        txtButtonNo: txtButtonNo,
        txtButtonCancel: txtButtonCancel
      };
      this.dialogs.push(newDialog);
    },
    printblob (blob, title = '', callback = () => {}) {
      let newDialog = {
        id: this.getRandomID(),
        blob: blob,
        title: title,
        callbackClose: callback,
        component: blobDialog,
        hasCloseButton: true
      };
      this.dialogs.push(newDialog);
    },
    loader (html, message, title = '') {
      const self = this;
      let newDialog = {
        id: this.getRandomID(),
        html: html,
        title: title,
        message: message,
        component: loading,
        hasCloseButton: false
      };
      this.dialogs.push(newDialog);
      return () => self.remove(newDialog);
    },
    batchResult (items, message, title = '') {
      let newDialog = {
        id: this.getRandomID(),
        items: items,
        message: message,
        title: title,
        component: batchResult,
        hasCloseButton: true
      };
      this.dialogs.push(newDialog);
    },
    remove: function (toast) {
      this.$log('remove Toast', toast.id, this.dialogs.map(x => x.id));
      let self = this;
      self.dialogs = self.dialogs.filter(x => x.id !== toast.id);
    },

    getRandomID () {
      return Math.random().toString(36).substring(7);
    }
  }
};

</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';

</style>
